export default {
  PESQUISAPLACA (state, info) {
      state.pesquisaplaca = { ...info }
  },
  PESQUISAPLACAPG (state, info) {
      state.pesquisaplacapg = info
  },
  PESQUISAPLACAPGBK (state, info) {
      state.pesquisaplacapgbk = info
  },
  PESQUISAQTDPLACAS (state, info) {
    state.pesquisaqtdplacas = info[0].total
  },
  BUSCARADAR (state, info) {
      state.buscaradar = { ...info }
  },
  BUSCACORPORACAO (state, info) {
      state.buscacorporacao = { ...info }
  },
  BUSCAIMAGEMP (state, info) {
      state.buscaimagemP = info
  },
  BUSCAIMAGEMZ (state, info) {
      state.buscaimagemZ = info
  },
  SALVARIMAGEM (state, info) {
      state.salvarimagem = info
  },
  PESQUISALPRBOTBACKEND (state, info) {
      state.pesquisalprbotbackend = info
  },
}